import { render, staticRenderFns } from "./add_tengxun.vue?vue&type=template&id=b195a686&scoped=true&"
import script from "./add_tengxun.vue?vue&type=script&lang=js&"
export * from "./add_tengxun.vue?vue&type=script&lang=js&"
import style0 from "./add_tengxun.vue?vue&type=style&index=0&id=b195a686&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b195a686",
  null
  
)

export default component.exports